var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"provider-logo text-center",style:(_vm.logoContainerStyle)},_vm._l((_vm.getProviderLogos()),function(providerLogo){return _c('img',{key:providerLogo,staticClass:"img-fluid",style:(_vm.logoImgStyle),attrs:{"src":providerLogo}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }